import React from 'react';
import Troubleshooting from '@/pages/Troubleshooting';

const TroubleshootingMachine = () => {
  return (
    <div className="space-y-6" data-testid="troubleshooting-machine-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Troubleshooting / Machine</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Machine Issues Wizard</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Focus on motion, stability, accuracy, and mechanical symptoms. Filtered from the full
            troubleshooting knowledge base.
          </p>
        </div>
      </div>
      <Troubleshooting />
    </div>
  );
};

export default TroubleshootingMachine;
